<div class="">
  <form
    class="is-vertical-align h-100 w-100 pointer-events-none finxForm"
    [ngStyle]="parentFormWidgetRowGap ? { gap: parentFormWidgetRowGap } : {}"
    [formGroup]="addBeneficiaryIntlForm"
  >
    @for (field of fieldsList; track $index) {
      <div class="w-100 mr-0">
        <finxone-input
          type="text"
          [formControlName]="field.title"
          [label]="field.item.requirement === 'required' ? field.label + '*' : field.label"
          [value]="addBeneficiaryIntlForm.get?.(field.title)?.value"
          [validationConfig]="fieldsValidationConfig[field.title]"
          (input)="valueChangeTrigger()"
        >
        </finxone-input>
      </div>
    }
  </form>
</div>
